import React, { useState, useEffect, useRef } from 'react';
// import { useHistory } from 'react-router-dom';
import { getporequirementlistFromServer, getporequirementbyidFromServer, getporequirementuserdetals} from '../../services/porequirement';
// import { HttpClient } from '../common/httpClient';

import $ from 'jquery';
import axios from 'axios';
import { getUploadedFileNativePath } from '../../services/common/credentials';
import { AgGridReact } from 'ag-grid-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Dropdown } from 'semantic-ui-react';
import Select from "react-select";
import './porequirement.css';

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Grid } from 'semantic-ui-react';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';


const P2PTrackerComponent = () => {
    // const history = useHistory();
    const [userdtl, setUserdtl] = useState();
    const [user, setUser] = useState();
    const [cardTitle, setCardTitle] = useState("Create New");

    const [boolPoreqList, setBoolPoreqList] = useState(false);

    const [paginationsize, setpaginationsize] = useState(25);
    const [rowData, setrowData] = useState(null);
    const [unapprovedlist, setunapprovedlist] = useState(null);
    const [approvedlist, setapprovedlist] = useState(null);
    const [listval, setListval] = useState('Create New');

    const [objporeq, setObjporeq] = useState({
        location: '',
        is_budgeted: '',
        date_of_delivery_expected: '',
        delivery_address: '',
        prf_number: '',
        perceived_benefits: '',
        requirement_date: '',
        department: '',
        reporting_manager: '',
        purpose: '',
        purchase_catagory: '',
        purchase_type: '',
        total_line_value: '',
        payment_term: '',
    });

    const [porequirmentDetails, setPorequirmentDetails] = useState([]);
    const [newporequirment, setNewporequirment] = useState({
        materialname: '',
        description: '',
        quantity: '',
        approxunitvalue: '',
        approxtotalvalue: '',
        typeofpurchase: '0', // Initialize with default value
    });

    const [porequirmenttab, setPorequirmenttab] = useState([]);

    const [tab, setTab] = useState(0);
    const [porequirmentquotationDetails, setPorequirmentquotationDetails] = useState([]);

    const [quoatefileupload, setQuoatefileupload] = useState(null);

    const [OptionsList, setOptionsList] = useState([]);
    const [OptionsList1, setOptionsList1] = useState([]);
    const [OptionsList2, setOptionsList2] = useState([]);



    //   const Unapproved = () => {
    //     setrowData(unapprovedlist);
    //     // setListval('Unapproved List');
    //   };

    const approved = () => {
        setrowData(approvedlist);
        // setListval('approved List');
        setBoolPoreqList(true);
    };

    const list = () => {
        setBoolPoreqList(false);
        getporequirementlist();
        
    };

    const options = [
        { label: '10', value: 10 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: '100', value: 100 },

    ];


    useEffect(() => {
        setUserdtl(JSON.parse(localStorage.getItem('useracess')));
        setUser(JSON.parse(localStorage.getItem('Userdtl')));
        getporequirementlist();
        getporeuirementuserdetails();
    }, []);


    const getporeuirementuserdetails = () => {
        const Indata = {
            tenant_id: 1,
            entity_id: 1,
            group_id: 1,
            module_id: 1,
            user_id: 33,
            department: 'SBI',
            user_name: 'SHABANA QAMAR',

        };
        console.log("inputporequirementlist1", Indata);
        var getFileUploadsList = getporequirementuserdetals();

        axios.post(getFileUploadsList[1], Indata, getFileUploadsList[0])
            .then((recieveddata) => {
                const tempresponsedata = recieveddata;
                let prfload = tempresponsedata?.data;
                console.log("porequirementlist1---", tempresponsedata);
                objporeq.reporting_manager=prfload.reporting_manager;
                objporeq.prf_number=prfload.prf_number;
                objporeq.budget_allocated=prfload.allocated_budget;
                objporeq.prf_number=prfload.prf_number;
                let locationlist=prfload.location_list.data;
                let approvelist=prfload.approver_list.data;
                let vendorlist=prfload.vendor_list.data;


                let OptionsList1 = [
                    
                    ...vendorlist.map(vendor => ({
                      value: vendor.vendor_name,
                      label: vendor.vendor_name
                    }))
                  ];

                  setOptionsList(OptionsList1);

                  let OptionsList2 = [
                    
                    ...locationlist.map(vendor => ({
                      value: vendor.location,
                      label: vendor.location
                    }))
                  ];

                  setOptionsList1(OptionsList2);

                  let OptionsList3 = [
                    
                    ...approvelist.map(vendor => ({
                      value: vendor.department,
                      label: vendor.department
                    }))
                  ];

                  setOptionsList2(OptionsList3);

            });
    };

    const getporequirementlist = () => {
        const Indata = {
            tenant_id: 1,
            entity_id: 1,
            group_id: 1,
            module_id: 1,
            user_id: 33,
            department: 'SBI',

        };
        console.log("inputporequirementlist", Indata);
        var getFileUploadsList = getporequirementlistFromServer();

        axios.post(getFileUploadsList[1], Indata, getFileUploadsList[0])
            .then((recieveddata) => {
                const tempresponsedata = recieveddata;
                let data = tempresponsedata?.data;
                console.log("porequirementlist---", tempresponsedata);
                console.log(user, userdtl)
                setapprovedlist(data?.approved_list)
                setrowData(data?.data);

            });
    };


    const handleSelectChange = (value ) => {

        console.log('Selected value:', value);
        setpaginationsize(value.value);
    };



    const [editporequirement, setEditporequirement] = useState({});
    const [poreq, setPoreq] = useState([]);

    const [tabs, setTabs] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    const EditPorequirementdetail = (id) => {
        const Indata = {
            requirement_id: id,
            tenant_id: 1,
            entity_id: 1,
            group_id: 1,
            module_id: 1,
            user_id: 33,
            user_name: 'SHABANA QAMAR',

        };
        console.log("edit porequirement list", Indata);
        var getFileUploadsList = getporequirementbyidFromServer();

        axios.post(getFileUploadsList[1], Indata, getFileUploadsList[0])
            .then((receivedData) => {

                const { po_requirement } = receivedData.data;
                const { prf_list, requirement_info, poquotation } = po_requirement;
                // console.log("prfeditresponse---", data);
                setEditporequirement(receivedData);
                // const editporeq = data['po_requirement'];
                // console.log('editporeq', editporeq);
                setPoreq(prf_list);
                setPorequirmentDetails(requirement_info);
                setPorequirmenttab(poquotation);


                setTabs(poquotation);
                console.log("prfreqinfo---", requirement_info);
                console.log("poquotation---", poquotation);


                // Remaining data assignment (similar to Angular code)
                const firstPoreq = prf_list[0];
                const updatedObjporeq = {

                    requirement_id: firstPoreq.requirement_id,
                    requirement_date: firstPoreq.requirement_date,
                    reporting_manager: firstPoreq.reporting_manager,
                    purpose: firstPoreq.purpose,
                    purchase_type: firstPoreq.purchase_type,
                    purchase_catagory: firstPoreq.purchase_catagory,
                    prf_number: firstPoreq.prf_number,
                    perceived_benefits: firstPoreq.perceived_benefits,
                    location: firstPoreq.location,
                    is_budgeted: firstPoreq.is_budgeted,
                    finalized_vendor: firstPoreq.finalized_vendor,
                    department: firstPoreq.department,
                    date_of_delivery_expected: firstPoreq.date_of_delivery_expected,
                    budget_allocated: firstPoreq.budget_allocated,
                    delivery_address: firstPoreq.delivery_address,
                    payment_term: firstPoreq.payment_term,
                    total_line_value: firstPoreq.total_line_value,
                    vendor_selection_reason: firstPoreq.vendor_selection_reason,
                    approver_mailid: firstPoreq.approver_mailid,
                    approver_name: firstPoreq.approver_name,
                    approver_department: firstPoreq.approver_department,
                    VendorFile_name: firstPoreq.VendorFile_name,
                    is_processed: firstPoreq.is_processed,
                    is_dept_head_approved: firstPoreq.is_dept_head_approved,
                    is_p2p_approved: firstPoreq.is_p2p_approved,
                    is_finance_approved: firstPoreq.is_finance_approved,
                    po_file_name: firstPoreq.po_file_name,
                    SupportFile_name: firstPoreq.SupportFile_name,
                };
                setObjporeq(updatedObjporeq);

            });
    };

    const ShowPorequirementdetail = (data) => {
        console.log('dataaaa', data.data);
        let data1 = data.data;
        setBoolPoreqList(true);
        console.log(data1['requirement_id'])
        EditPorequirementdetail(data1['requirement_id'])
    };


    var gridColumns = [

        { field: 'prf_number', headerName: 'PRF Number', sortable: true, filter: true, resizable: true },
        { field: 'requirement_date', headerName: 'requirement_date', sortable: true, filter: true, resizable: true },
        { field: 'po_file_name', headerName: 'po Doc', sortable: true, filter: true, resizable: true },
        { field: 'department', headerName: 'department', sortable: true, filter: true, resizable: true },
        { field: 'purpose', headerName: 'purpose', sortable: true, filter: true, resizable: true },
        { field: 'purchase_catagory', headerName: 'purchase_catagory', sortable: true, filter: true, resizable: true },
        { field: 'po_status', headerName: 'status', sortable: true, filter: true, resizable: true },
        { field: 'Comments', headerName: 'Comments', sortable: true, filter: true, resizable: true },

        {
            headerName: 'Edit',
            cellRendererFramework: (params) => (
                <button
                    onClick={() => ShowPorequirementdetail(params)}
                    className="edit-button"
                >
                    <i className="fa fa-edit" aria-hidden="true"></i>
                </button>
            ),
            width: 80,
        },

    ]

    const handleMaterialNameChange = (e, index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails[index].materialname = e.target.value;
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const handleDescriptionChange = (e, index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails[index].description = e.target.value;
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const handleQuantityChange = (e, index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails[index].quantity = e.target.value;
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const handleApproxUnitValueChange = (e, index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails[index].approxunitvalue = e.target.value;
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const handleApproxTotalValueChange = (e, index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails[index].approxtotalvalue = e.target.value;
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const handleNewMaterialNameChange = (e) => {
        setNewporequirment({
            ...newporequirment,
            materialname: e.target.value,
        });
    };

    const handleNewDescriptionChange = (e) => {
        setNewporequirment({
            ...newporequirment,
            description: e.target.value,
        });
    };

    const handleNewQuantityChange = (e) => {
        setNewporequirment({
            ...newporequirment,
            quantity: e.target.value,
        });
    };

    const handleNewApproxUnitValueChange = (e) => {
        setNewporequirment({
            ...newporequirment,
            approxunitvalue: e.target.value,
        });
    };

    const handleNewApproxTotalValueChange = (e) => {
        setNewporequirment({
            ...newporequirment,
            approxtotalvalue: e.target.value,
        });
    };

    const handleVendorTypeChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendortype = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorNameChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendorname = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorCodeChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendorcode = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorLocationChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendorlocation = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorAddressChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendoraddress = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorGSTNumberChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendorgstno = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleVendorEmailIDChange = (e, index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab[index].vendoremailid = e.target.value;
        setPorequirmenttab(updatedPorequirmenttab);
    };

    const handleMaterialNameQuotationChange = (e, index) => {
        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails[index].materialname = e.target.value;
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const handleDescriptionQuotationChange = (e, index) => {
        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails[index].description = e.target.value;
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const handleQuantityQuotationChange = (e, index) => {
        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails[index].quantity = e.target.value;
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const handleApproxUnitValueQuotationChange = (e, index) => {
        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails[index].approxunitvalue = e.target.value;
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const handleApproxTotalValueQuotationChange = (e, index) => {
        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails[index].approxtotalvalue = e.target.value;
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const addFieldValue = () => {
        setPorequirmentDetails([...porequirmentDetails, { ...newporequirment }]);
        setNewporequirment({
            materialname: '',
            description: '',
            quantity: '',
            approxunitvalue: '',
            approxtotalvalue: '',
            typeofpurchase: '0',
        });
    };

    const deleteFieldValue = (index) => {
        const updatedPorequirmentDetails = [...porequirmentDetails];
        updatedPorequirmentDetails.splice(index, 1);
        setPorequirmentDetails(updatedPorequirmentDetails);
    };

    const addQutation = () => {
        setPorequirmenttab([...porequirmenttab, { vendortype: '', vendorname: '', vendorcode: '', vendorlocation: '', vendoraddress: '', vendorgstno: '', vendoremailid: '' }]);
        setPorequirmentquotationDetails([...porequirmentquotationDetails, { materialname: '', description: '', quantity: '', approxunitvalue: '', approxtotalvalue: '' }]);
    };

    const deleteQuotation = (index) => {
        const updatedPorequirmenttab = [...porequirmenttab];
        updatedPorequirmenttab.splice(index, 1);
        setPorequirmenttab(updatedPorequirmenttab);

        const updatedPorequirmentquotationDetails = [...porequirmentquotationDetails];
        updatedPorequirmentquotationDetails.splice(index, 1);
        setPorequirmentquotationDetails(updatedPorequirmentquotationDetails);
    };

    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleCollapse = () => {
        setIsCollapsed(prevState => !prevState);
    };

    const [isBudgetCollapsed, setIsBudgetCollapsed] = useState(true);

    const toggleBudgetCollapse = () => {
        setIsBudgetCollapsed(!isBudgetCollapsed);
    };



    //   const [porequirmentDetails, setPorequirmentDetails] = useState([...]); // Your state for existing rows
    //   const [newporequirment, setNewporequirment] = useState({ ... }); // Your state for new row

    const handleTypeOfPurchaseChange = (e, index) => {
        const { value } = e.target;
        const updatedDetails = [...porequirmentDetails];
        updatedDetails[index] = { ...updatedDetails[index], typeofpurchase: value };
        setPorequirmentDetails(updatedDetails);
    };

    const handleNewTypeOfPurchaseChange = (e) => {
        const { value } = e.target;
        setNewporequirment(prevState => ({ ...prevState, typeofpurchase: value }));
    };



    const addTab = () => {
        const newTabs = [...tabs, { qutationname: `Quotation${tabs.length + 1}` }];
        setTabs(newTabs);
        setActiveTab(newTabs.length - 1);
    };

    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    // Rest of the code...
    

    const selectDepartment = (selectedOption) => {
        setObjporeq({
            ...objporeq,
            department: selectedOption,
        })
        console.log("Selected option:", selectedOption);
      };
    
      const selectLocation = (selectedOption) => {
        setObjporeq({
            ...objporeq,
            location: selectedOption,
        })
        console.log("Selected option:", selectedOption);
      };


    const Requirementheader = () => {


        return (
            <>
                <div
                    
                >
                    <div className="row">
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput2" className="mb-1 porequirement_label">PRF No</label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control pull-right porequirement_input"
                                    value={objporeq.prf_number}
                                    onChange={(e) =>
                                        setObjporeq({
                                            ...objporeq,
                                            prf_number: e.target.value,
                                        })
                                    }
                                    id="prfnumber"
                                    name="prfnumber"
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput2" className="mb-1 porequirement_label">Requirement Date</label>
                            <div className="input-group date">
                                <input
                                    type="date"
                                    className="form-control pull-right porequirement_input"
                                    value={objporeq.requirement_date}
                                    onChange={(e) =>
                                        setObjporeq({
                                            ...objporeq,
                                            requirement_date: e.target.value,
                                        })
                                    }
                                    id="datepicker"
                                    name="datepicker"
                                    required
                                    tabIndex="1"
                                    data-validation-required-message="This Requirement Details required"
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Department</label>
                            <Select
                                    options={OptionsList2}
                                    placeholder="Select Department"
                                    value={objporeq.department}
                                    onChange={selectDepartment}
                                    isSearchable={true}
                                    
                                    className="custom-select form-control porequirement_input"
                            />
                            
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Reporting Manager</label>
                            <input
                                type="text"
                                value={objporeq.reporting_manager}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        reporting_manager: e.target.value,
                                    })
                                }
                                name="reportingmanager"
                                id="reportingmanager"
                                tabIndex="6"
                                className="form-control form-control-sm porequirement_input"
                            />
                        </div>

                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Purpose</label>
                            <input
                                type="text"
                                value={objporeq.purpose}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        purpose: e.target.value,
                                    })
                                }
                                name="purpose"
                                id="purpose"
                                tabIndex="3"
                                className="form-control form-control-sm porequirement_input"
                                required
                                data-validation-required-message="This Purpose is required"
                            />
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Purchase Category</label>
                            <select
                                className="custom-select form-control porequirement_input"
                                value={objporeq.purchase_catagory}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        purchase_catagory: e.target.value,
                                    })
                                }
                                id="purchasecategory"
                                name="purchasecategory"
                                required
                                tabIndex="4"
                                data-validation-required-message="This Purchase Category required"
                            >
                                <option value="0">Select Purchase Category</option>
                                <option value="Regular">Regular</option>
                                <option value="Special">Special</option>
                                <option value="Recuring">Recuring</option>
                            </select>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Type of Purchase</label>
                            <select
                                className="custom-select form-control porequirement_input"
                                value={objporeq.purchase_type}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        purchase_type: e.target.value,
                                    })
                                }
                                id="typeofpurchase"
                                name="typeofpurchase"
                                required
                                tabIndex="5"
                                data-validation-required-message="This Type of Purchase required"
                            >
                                <option value="0">Select Type of Purchase</option>
                                <option value="Opex">Opex</option>
                                <option value="Capex">Capex</option>
                                <option value="Online">Online</option>
                            </select>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Location</label>
                            <Select
                                    options={OptionsList1}
                                    placeholder="Select Department"
                                    value={objporeq.location}
                                    onChange={selectLocation}
                                    isSearchable={true}
                                    className="form-control form-control-sm porequirement_input"
                            />
                            
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Budgeted</label>
                            <select
                                className="custom-select form-control porequirement_input"
                                value={objporeq.is_budgeted}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        is_budgeted: e.target.value,
                                    })
                                }
                                id="budgeted"
                                name="budgeted"
                                required
                                tabIndex="2"
                                data-validation-required-message="This budgeted required"
                            >
                                <option value="">Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput2" className="mb-1 porequirement_label">Date of Delivery Expected</label>
                            <div className="input-group date">
                                <input
                                    type="date"
                                    className="form-control pull-right porequirement_input"
                                    value={objporeq.date_of_delivery_expected}
                                    onChange={(e) =>
                                        setObjporeq({
                                            ...objporeq,
                                            date_of_delivery_expected: e.target.value,
                                        })
                                    }
                                    id="deliveryexpecteddate"
                                    name="deliveryexpecteddate"
                                    required
                                    tabIndex="1"
                                    data-validation-required-message="This Date of Delivery Expected is required"
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput2" className="mb-1 porequirement_label">Requirement Total</label>
                            <div className="input-group date">
                                <input
                                    type="number"
                                    className="form-control pull-right porequirement_input"
                                    value={objporeq.total_line_value}
                                    onChange={(e) =>
                                        setObjporeq({
                                            ...objporeq,
                                            total_line_value: e.target.value,
                                        })
                                    }
                                    id="deliveryexpecteddate"
                                    name="deliveryexpecteddate"
                                    required
                                    tabIndex="1"
                                    data-validation-required-message="This Date of Delivery Expected is required"
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">Delivery Address</label>
                            <textarea
                                className="form-control porequirement_input"
                                value={objporeq.delivery_address}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        delivery_address: e.target.value,
                                    })
                                }
                                name="deliveryaddress"
                                id="deliveryaddress"
                                tabIndex="7"
                                maxLength="800"
                            ></textarea>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="userinput2" className="mb-1 porequirement_label">PaymentTerm</label>
                            <div className="input-group date">
                                <input
                                    type="text"
                                    className="form-control pull-right porequirement_input"
                                    value={objporeq.payment_term}
                                    onChange={(e) =>
                                        setObjporeq({
                                            ...objporeq,
                                            payment_term: e.target.value,
                                        })
                                    }
                                    id="deliveryexpecteddate"
                                    name="deliveryexpecteddate"
                                    required
                                    tabIndex="1"
                                    data-validation-required-message="This Date of Delivery Expected is required"
                                />
                            </div>
                        </div>
                        <div className="form-group col-md-12 mb-2">
                            <label htmlFor="userinput1" className="mb-1 porequirement_label">perceived Benefits</label>
                            <textarea
                                className="form-control porequirement_input"
                                value={objporeq.perceived_benefits}
                                onChange={(e) =>
                                    setObjporeq({
                                        ...objporeq,
                                        perceived_benefits: e.target.value,
                                    })
                                }
                                name="receivedbenefit"
                                id="receivedbenefit"
                                tabIndex="8"
                                maxLength="1000"
                            ></textarea>
                        </div>
                    </div>
                </div>
            </>
        );
    }


    const Requirementinfo = () => {


        return (
            <>
                <div>

                    <div className="row">
                        <div className="m-0">
                            <table className="table table-xs table-hover table-bordered nowrap width-per-100 no-footer dataTable">
                                <thead>
                                    <tr className="bg-light-gray2">
                                        <th>Material/Service Name</th>
                                        <th>Description</th>
                                        <th>Budget Category</th>
                                        <th>Quantity</th>
                                        <th>Approx Unit Value</th>
                                        <th>Approx Total Value</th>
                                        <th style={{ textAlign: 'center' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {porequirmentDetails?.map((cost, index) => (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-table"
                                                    name={`materialname_${index}`}
                                                    value={cost.material_name}
                                                    onChange={(e) => handleMaterialNameChange(e, index)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-table"
                                                    name={`description_${index}`}
                                                    value={cost.line_description}
                                                    onChange={(e) => handleDescriptionChange(e, index)}
                                                />
                                            </td>

                                            <td>
                                                <div className="form-group col-md-4 mb-2">

                                                    <select
                                                        className="custom-select form-control"
                                                        value={cost.budget_category}
                                                        onChange={(e) => handleTypeOfPurchaseChange(e, index)} // Define your handler function
                                                        id={`typeofpurchase_${index}`}
                                                        name={`typeofpurchase_${index}`}
                                                        required
                                                        tabIndex="5"
                                                        data-validation-required-message="This Type of Purchase required"
                                                        style={{ 'width': '10em' }}
                                                    >
                                                        <option value="0">Select Type of Purchase</option>
                                                        <option value="Opex">Opex</option>
                                                        <option value="Capex">Capex</option>
                                                        <option value="Online">Online</option>
                                                    </select>
                                                </div>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-table"
                                                    name={`quantity_${index}`}
                                                    value={cost.quantity}
                                                    onChange={(e) => handleQuantityChange(e, index)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-table"
                                                    name={`approxunitvalue_${index}`}
                                                    value={cost.unit_value}
                                                    onChange={(e) => handleApproxUnitValueChange(e, index)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-table"
                                                    name={`approxtotalvalue_${index}`}
                                                    value={cost.total_value}
                                                    onChange={(e) => handleApproxTotalValueChange(e, index)}
                                                />
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    className="btn btn-raised btn-outline-danger ml-2"
                                                    onClick={() => deleteFieldValue(index)}
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-table"
                                                name="materialname"
                                                value={newporequirment.material_name}
                                                onChange={handleNewMaterialNameChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-table"
                                                name="description"
                                                value={newporequirment.line_description}
                                                onChange={handleNewDescriptionChange}
                                            />
                                        </td>

                                        <td>
                                            <div className="form-group col-md-4 mb-2">

                                                <select
                                                    className=" form-control"
                                                    value={newporequirment.budget_category}
                                                    onChange={handleNewTypeOfPurchaseChange} // Define your handler function
                                                    id="new_typeofpurchase"
                                                    name="new_typeofpurchase"
                                                    required
                                                    tabIndex="5"
                                                    data-validation-required-message="This Type of Purchase required"
                                                    style={{ 'width': '10em' }}
                                                >
                                                    <option value="0">Select Type of Purchase</option>
                                                    <option value="Opex">Opex</option>
                                                    <option value="Copex">Copex</option>
                                                    <option value="Online">Online</option>
                                                </select>
                                            </div>
                                        </td>

                                        <td>
                                            <input
                                                type="text"
                                                className="form-table"
                                                name="quantity"
                                                value={newporequirment.quantity}
                                                onChange={handleNewQuantityChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-table"
                                                name="approxunitvalue"
                                                value={newporequirment.unit_value}
                                                onChange={handleNewApproxUnitValueChange}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-table"
                                                name="approxtotalvalue"
                                                value={newporequirment.total_value}
                                                onChange={handleNewApproxTotalValueChange}
                                            />
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button
                                                className="btn btn-raised btn-sm btn-outline-info ml-2"
                                                onClick={addFieldValue}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button>
                                            <button
                                                className="btn btn-raised btn-sm btn-outline-default ml-2"
                                                title="Clear Data"
                                                onClick={() => setNewporequirment({
                                                    material_name: '',
                                                    line_description: '',
                                                    budget_category: '',
                                                    quantity: '',
                                                    unit_value: '',
                                                    total_value: '',
                                                })}
                                            >
                                                <i className="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const QuotationInfo = () => {

        return (
            <>
                <div
                    id="collapsePorequirementbudget"
                    className={`collapse${isBudgetCollapsed ? ' show' : ''} position-relative`}
                    role="tabpanel"
                >
                    <div className="row">
                        {tabs && (
                            <ul className="nav nav-pills justify-content-end margin-bottom">
                                {tabs?.map((poqutation, index) => (
                                    <li className="nav-item" key={index}>
                                        <a
                                            href={`#poqutation_${index}`}
                                            className={`nav-link ${activeTab === index ? 'active show' : ''}`}
                                            data-toggle="tab"
                                            aria-expanded="false"
                                            onClick={() => setActiveTab(index)}
                                        >
                                            poqutation_{index}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <div className="text-right" style={{ paddingTop: '5px' }}>
                            <button className="btn btn-raised btn-outline-danger ml-2" onClick={addTab}>
                                <i className="fa fa-plus"></i> Add Quotation
                            </button>
                        </div>

                        <div className="tab-content">
                            {tabs.map((poqutation, index) => (
                                <div
                                    key={index}
                                    id={`poqutation_${index}`}
                                    className={`tab-pane ${activeTab === index ? 'active show' : ''}`}
                                >
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendortype_${index}`} className="mb-1 porequirement_label">Vendor Type</label>
                                            <select
                                                className="custom-select form-control porequirement_input"
                                                id={`vendortype_${index}`}
                                                name={`vendortype_${index}`}
                                                value={poqutation?.vendor_type}
                                                onChange={(e) => handleVendorTypeChange(e, index)}
                                            >
                                                <option value="0">Select</option>
                                                <option value="1">Existing</option>
                                                <option value="2">New</option>
                                            </select>
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendorname_${index}`} className="mb-1 porequirement_label">Vendor Name</label>
                                            {poqutation?.vendor_type === '1' ? (
                                                <select
                                                    className="custom-select form-control porequirement_input"
                                                    id={`vendorname_${index}`}
                                                    name={`vendorname_${index}`}
                                                    value={poqutation?.vendor_name}
                                                    onChange={(e) => handleVendorNameChange(e, index)}
                                                >
                                                    <option value="0">Select</option>
                                                    <option value="Radison">Radison</option>
                                                    <option value="Nisson">Nisson</option>
                                                </select>
                                            ) : (
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm porequirement_input"
                                                    id={`vendorname_${index}`}
                                                    name={`vendorname_${index}`}
                                                    value={poqutation?.vendor_name}
                                                    onChange={(e) => handleVendorNameChange(e, index)}
                                                />
                                            )}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendorcode_${index}`} className="mb-1 porequirement_label">Vendor Code</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm porequirement_input"
                                                id={`vendorcode_${index}`}
                                                name={`vendorcode_${index}`}
                                                value={poqutation?.vendor_code}
                                                onChange={(e) => handleVendorCodeChange(e, index)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendorlocation_${index}`} className="mb-1 porequirement_label">Vendor Location</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm porequirement_input"
                                                id={`vendorlocation_${index}`}
                                                name={`vendorlocation_${index}`}
                                                value={poqutation?.vendor_location}
                                                onChange={(e) => handleVendorLocationChange(e, index)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendoraddress_${index}`} className="mb-1 porequirement_label">Vendor Address</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm porequirement_input"
                                                id={`vendoraddress_${index}`}
                                                name={`vendoraddress_${index}`}
                                                value={poqutation?.vendor_address}
                                                onChange={(e) => handleVendorAddressChange(e, index)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendorgstno_${index}`} className="mb-1 porequirement_label">Vendor GST Number</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm porequirement_input"
                                                id={`vendorgstno_${index}`}
                                                name={`vendorgstno_${index}`}
                                                value={poqutation?.gst_number}
                                                onChange={(e) => handleVendorGSTNumberChange(e, index)}
                                            />
                                        </div>
                                        <div className="form-group col-md-4">
                                            <label htmlFor={`vendoremailid_${index}`} className="mb-1 porequirement_label">Vendor Email ID</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm porequirement_input"
                                                id={`vendoremailid_${index}`}
                                                name={`vendoremailid_${index}`}
                                                value={poqutation?.vendor_emailid}
                                                onChange={(e) => handleVendorEmailIDChange(e, index)}
                                            />
                                        </div>
                                        {/* ...other form fields */}
                                        <div className="form-group col-md-4 mb-2">
                                            <label htmlFor={`quotationfile_${index}`} className="mb-1 porequirement_label">Quotation Doc</label>
                                            <input
                                                type="file"
                                                className='porequirement_input'
                                                id={`quotationfile_${index}`}
                                                name={`quotationfile_${index}`}
                                                // value={poqutation?.quotationfile_name}
                                                onChange={(e) => quoatefileupload(e.target.files)}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="m-0">
                                            <table className="table table-xs table-hover table-bordered nowrap width-per-100 no-footer dataTable">
                                                <thead>
                                                    <tr className="bg-light-gray2">
                                                        <th>Material/Service Name</th>
                                                        <th>Description</th>
                                                        <th>Quantity</th>
                                                        <th>Approx Unit Value</th>
                                                        <th>Approx Total Value</th>
                                                        <th style={{ textAlign: 'center' }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {porequirmentquotationDetails?.map((cost, i) => (
                                                        <tr key={i}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-table"
                                                                    name={`materialname_${i}`}
                                                                    value={cost?.materialname}
                                                                    onChange={(e) => handleMaterialNameQuotationChange(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-table"
                                                                    name={`description_${i}`}
                                                                    value={cost?.description}
                                                                    onChange={(e) => handleDescriptionQuotationChange(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-table"
                                                                    name={`quantity_${i}`}
                                                                    value={cost?.quantity}
                                                                    onChange={(e) => handleQuantityQuotationChange(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-table"
                                                                    name={`approxunitvalue_${i}`}
                                                                    value={cost?.approxunitvalue}
                                                                    onChange={(e) => handleApproxUnitValueQuotationChange(e, i)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-table"
                                                                    name={`approxtotalvalue_${i}`}
                                                                    value={cost?.approxtotalvalue}
                                                                    onChange={(e) => handleApproxTotalValueQuotationChange(e, i)}
                                                                />
                                                            </td>
                                                            <td style={{ textAlign: 'center' }}>
                                                                <button
                                                                    className="btn btn-raised btn-outline-danger ml-2"
                                                                    onClick={() => deleteQuotation(i)}
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    <tr>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-table"
                                                                name="materialname"
                                                                value={newporequirment?.materialname}
                                                                onChange={handleNewMaterialNameChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-table"
                                                                name="description"
                                                                value={newporequirment?.description}
                                                                onChange={handleNewDescriptionChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-table"
                                                                name="quantity"
                                                                value={newporequirment?.quantity}
                                                                onChange={handleNewQuantityChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-table"
                                                                name="approxunitvalue"
                                                                value={newporequirment?.approxunitvalue}
                                                                onChange={handleNewApproxUnitValueChange}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-table"
                                                                name="approxtotalvalue"
                                                                value={newporequirment?.approxtotalvalue}
                                                                onChange={handleNewApproxTotalValueChange}
                                                            />
                                                        </td>
                                                        <td style={{ textAlign: 'center' }}>
                                                            <button
                                                                className="btn btn-raised btn-sm btn-outline-info ml-2"
                                                                onClick={addFieldValue}
                                                            >
                                                                <i className="fa fa-plus"></i>
                                                            </button>
                                                            <button
                                                                className="btn btn-raised btn-sm btn-outline-default ml-2"
                                                                title="Clear Data"
                                                                onClick={() => setNewporequirment({
                                                                    materialname: '',
                                                                    description: '',
                                                                    quantity: '',
                                                                    approxunitvalue: '',
                                                                    approxtotalvalue: '',
                                                                })}
                                                            >
                                                                <i className="fa fa-times"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            ))}


                        </div>
                    </div>

                </div>
            </>
        );
    }


    const QuotationProcess = () => {

        return (
            <>
                <div className="position-relative collapse show" id="collapsePorequirementprocess" role="tabpanel">
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label htmlFor="approver_name" className="mb-1 porequirement_label">Approver Name</label>
                            <Select
                                    options={OptionsList}
                                    placeholder="Select Approver name"
                                    value={objporeq?.approver_name}
                                    onChange={selectDepartment}
                                    isSearchable={true}
                                    
                                    className="custom-select form-control porequirement_input"
                            />
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="approver_mailid" className="mb-1 porequirement_label">Approver MailID</label>
                            <input className="form-control porequirement_input" disabled id="approver_mailid" name="approver_mailid" type="text" />
                        </div>
                        <div className="form-group col-md-4">
                            <label htmlFor="approver_department" className="mb-1 porequirement_label">Approver Department</label>
                            <input className="form-control porequirement_input" disabled id="approver_department" name="approver_department" type="text" />
                        </div>
                        <div className="form-group col-md-4 mb-2">
                            <label htmlFor="SupportingFile" className="mb-1 porequirement_label">Supporting Doc</label>
                            <input id="SupportingFile" name="SupportingFile" type="file" />
                        </div>
                        <div className="form-group col-md-4 mt-2">
                            <button className="btn btn-raised btn-info btn-min-width mr-1 mt-1" onClick={openModal}>
                                <i className="fa fa-check-square-o"></i> Compare Quotation
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-4">
                            <label htmlFor="vendorname" className="mb-1 porequirement_label">Final Vendor Selection</label>
                            <select className="custom-select form-control porequirement_input" id="vendorname" name="vendorname">
                                {/* Your options here */}
                            </select>
                        </div>
                        <div className="form-group col-md-8 mb-2">
                            <label htmlFor="receivedbenefit" className="mb-1 porequirement_label">Comment</label>
                            <textarea className="form-control porequirement_input" id="receivedbenefit" maxLength="1200" name="receivedbenefit" />
                        </div>
                    </div>
                    {/* Remaining content */}


                    {showModal && (
                        <div className="modal fade show" id="quotation_Modal" role="dialog" style={{ display: 'block', paddingRight: '17px' }}>
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="quotation_Modal">Quotation Comparison</h5>
                                        <button className="close" data-dismiss="modal" aria-label="Close" type="button" onClick={closeModal}>
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="form-group col-md-4">
                                                <h6 className="modal-title" id="quotation_Modal">Quotation 1</h6>
                                                <div className="row quotation">
                                                    <div className="form-group col-md-4">
                                                        <table>
                                                            <tr>
                                                                <th className="pad-14"><label htmlFor="userinput2">Vendor Name</label></th>
                                                                <th className="pad-14"> Fast Look (S K Najim) </th>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <table className="table table-striped table-bordered">
                                                            <thead>
                                                                <tr className="bg-light-gray2">
                                                                    <th> Material/Service Name </th>
                                                                    <th> Description </th>
                                                                    <th> Quantity </th>
                                                                    <th> Approx Unit Value </th>
                                                                    <th> Approx Total Value </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {/* ... (iterate and display data) ... */}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer"></div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }

    const ResourceMasterTabs = () => {
        const [value, setValue] = useState("1");


        const handleChange = (event, newValue) => {
            console.log('newValue' + newValue);

            setValue(newValue);
        };

        return (

            <Box>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                            <Tab label="Requirement Header" value="1" />
                            <Tab label="Requirement Info" value="2" />
                            <Tab label="Quotation Info" value="3" />
                            <Tab label="Quotation Process" value="4" />
                        </TabList>
                    </Box>
                    <TabPanel value="1" style={{ backgroundColor: 'white' }}><Requirementheader /></TabPanel>
                    <TabPanel value="2" style={{ backgroundColor: 'white' }}><Requirementinfo /></TabPanel>
                    <TabPanel value="3" style={{ backgroundColor: 'white' }}><QuotationInfo /></TabPanel>
                    <TabPanel value="4" style={{ backgroundColor: 'white' }}><QuotationProcess /></TabPanel>
                </TabContext>
            </Box>

        );
    }

    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: -5,
            fontSize: 14,
        })
    };

    return (
        <>



            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid">


                        <div className="row">
                            <div className="col-12">
                                <div>
                                    <form className="form_porequi" >
                                        <h4 className="header d-flex justify-content-between mt-3">
                                            {cardTitle}
                                            <div className="text-right">
                                                <button
                                                    type="button"
                                                    className="btn btn-min-width mr-1 mb-1"

                                                    onClick={list}
                                                    style={{ background: 'var(--blue)', width: '7em', color: '#f3f4f6', marginRight: '1.2em' }}
                                                    hidden={!boolPoreqList}
                                                >
                                                    <i className="ft-package"></i> List
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-min-width mr-1 mb-1"
                                                    style={{ background: 'var(--blue)', width: '7em', color: '#f3f4f6' }}
                                                    onClick={approved}
                                                    hidden={boolPoreqList}
                                                >
                                                    <i className="ft-package"></i> Create
                                                </button>
                                            </div>
                                        </h4>
                                        {/* header end */}
                                        <div className="body" hidden={!boolPoreqList}>
                                            <div>
                                                <ResourceMasterTabs />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>   

                    </div>
                </section>


                <div className="report" hidden={boolPoreqList}>

                    <div className='row'>
                        <div className='col-md-3'>
                            <Select
                                options={options}
                                placeholder="Select an option"
                                defaultValue={25}
                                onChange={handleSelectChange}
                                styles={customStyles}
                                
                            />
                        </div>
                    </div>
                    <div className="ag-theme-balham report-layer" style={{ width: '100%' }}>
                        <AgGridReact
                            columnDefs={gridColumns}
                            rowData={rowData}
                            paginationPageSize={paginationsize}
                            pagination={true}
                            animateRows={true}
                            rowSelection={'multiple'}
                            groupSelectsChildren={true}

                            suppressAggAtRootLevel={true}
                            suppressRowClickSelection={true}

                        >
                        </AgGridReact>
                    </div>
                </div>



            </div>
        </>
    );

};

export default P2PTrackerComponent;